import Shipping from "../pages/Shipping";

export const paymentRoutes = [
    { path: "/shipping", name: "Shipping", Component: Shipping },
]